import _Provider from './TabularDatasetProvider'
import { useTabularDatasetConfiguration as _useTabularDatasetConfiguration } from './hooks'

export const TabularDatasetProvider = _Provider
export const useTabularDatasetConfiguration = _useTabularDatasetConfiguration
